import './AdminInstitutionViewSetting.js';
import './booking.js';
import './category.js';
import './counseling.js';
import './global-notification.js';
import './lecturer-data.js';
import './lecturer.js';
import './multiCertificate.js';
import './participation.js';
import './product-entry-requirement.js';
import './product.js';
import './recommendations.js';
import './statistic.js';
import './teaching.js';
import './user-data.js';
import './users.js';
import './workshop-set.js';
import './workshop.js';
